module.exports = __webpack_public_path__ + "img/city_box3.4292ab88.png";